import { apiHeaderWithSiteId, homeAPIUrl } from "./../../utils/urls";
import { loadingEnd, loadingStart } from "./root.actions";
export const homePageActionTypes = {
  FETCH_HOMEPAGE_DATA_SUCCESS: "FETCH_HOMEPAGE_DATA_SUCCESS",
  FETCH_HOMEPAGE_DATA_FAILURE: "FETCH_HOMEPAGE_DATA_FAILURE",
};

const fetchHomePageDataSuccessAction = (data) => {
  return {
    type: homePageActionTypes.FETCH_HOMEPAGE_DATA_SUCCESS,
    data,
  };
};

export const fetchGetHome = (isAuth, token) => (dispatch) => {
  dispatch(loadingStart());
  
  // Create new header object to avoid mutation
  let headers = { ...apiHeaderWithSiteId };
  
  // Remove Authorization if it exists from previous calls
  if (headers.Authorization) {
    delete headers.Authorization;
  }
  
  // Set Content-Language header from localStorage for proper translation
  const currentLanguage = localStorage.getItem("language");
  if (currentLanguage) {
    headers["Content-Language"] = currentLanguage;
  }
  
  // Only add Authorization header if user is authenticated AND token is valid
  // Check for: isAuth is true, token exists, token is not "null" string, token is not empty, and token has valid length
  if (isAuth === true && token && typeof token === 'string' && token !== "null" && token !== "" && token.trim().length > 10) {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(homeAPIUrl, {
    method: "GET",
    headers: headers,
  })
    .then((response) => response.json())
    .then((data) => {
      dispatch(fetchHomePageDataSuccessAction(data));
      dispatch(loadingEnd());
      return data;
    })
    .catch((err) => {
      console.log(err);
      dispatch(loadingEnd());
      return err;
    });
};
